import { useForm } from '@conform-to/react'
import { parseWithZod, getZodConstraint } from '@conform-to/zod'
import { signupFormSchema } from './signupFormSchema'

export const useSignupForm = () => {
  const defaultValues = {
    name: '',
    email: '',
    password: '',
    termAndPrivacy: false,
  }
  const [form, data] = useForm({
    constraint: getZodConstraint(signupFormSchema),
    onValidate({ formData }) {
      return parseWithZod(formData, { schema: signupFormSchema })
    },
  })

  return {
    form,
    data,
    defaultValues,
  }
}
